export default __webpack_public_path__ + "static/media/contact-us-classic-02.99806013.jpg";